import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@adsk/alloy-react-tooltip';
import { AlertInformationIcon } from '@adsk/alloy-react-icon';
import {
  labelStyle as defaultLabelStyle,
  requiredStyle,
  tooltipIconStyle,
} from './styles';

const Label = ({
  text,
  required,
  tooltipMessage,
  delayTooltipHide,
  size,
  labelStyle,
}) => (
  <div css={{ ...defaultLabelStyle, ...labelStyle }}>
    <div>{text}</div>
    {required && <div css={requiredStyle}>&nbsp;*</div>}
    {tooltipMessage && (
      <Tooltip
        shouldWrapChildren={false}
        content={tooltipMessage}
        placement={Tooltip.PLACEMENTS.RIGHT}
        delayHide={delayTooltipHide ? 1000 : 0}
      >
        <AlertInformationIcon size={size} style={tooltipIconStyle} />
      </Tooltip>
    )}
  </div>
);

Label.propTypes = {
  delayTooltipHide: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  labelStyle: PropTypes.object,
  required: PropTypes.bool,
  size: PropTypes.number,
  text: PropTypes.string.isRequired,
  tooltipMessage: PropTypes.node,
};

Label.defaultProps = {
  delayTooltipHide: false,
  required: false,
  size: 16,
  labelStyle: {},
};

export default Label;
